import { __decorate, __extends, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import { EntitySelectComponent } from 'src/Foundation/Design/app';
import template from './faq-category-select.component.html';
var FaqCategorySelectComponent = (function (_super) {
    __extends(FaqCategorySelectComponent, _super);
    function FaqCategorySelectComponent() {
        return _super.call(this) || this;
    }
    FaqCategorySelectComponent.prototype.ngOnChanges = function () {
        this.entities = this.faqCategories || [];
    };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], FaqCategorySelectComponent.prototype, "faqCategories", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqCategorySelectComponent.prototype, "clearAllText", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqCategorySelectComponent.prototype, "emptySelectionText", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqCategorySelectComponent.prototype, "onSelectionChange", void 0);
    FaqCategorySelectComponent = __decorate([
        Component({
            selector: 'faqCategorySelect',
            template: template,
        }),
        __metadata("design:paramtypes", [])
    ], FaqCategorySelectComponent);
    return FaqCategorySelectComponent;
}(EntitySelectComponent));
export { FaqCategorySelectComponent };
